import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=bf0eaa96&scoped=true"
import script from "./AlertDetail.vue?vue&type=script&lang=js"
export * from "./AlertDetail.vue?vue&type=script&lang=js"
import style0 from "./AlertDetail.vue?vue&type=style&index=0&id=bf0eaa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0eaa96",
  null
  
)

export default component.exports